import { render, staticRenderFns } from "./AdminMasterPassword.vue?vue&type=template&id=263f5aca&scoped=true&"
import script from "./AdminMasterPassword.vue?vue&type=script&lang=js&"
export * from "./AdminMasterPassword.vue?vue&type=script&lang=js&"
import style0 from "./AdminMasterPassword.vue?vue&type=style&index=0&id=263f5aca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263f5aca",
  null
  
)

export default component.exports